import { json } from 'd3-fetch'; // eslint-disable-line
// import { appendBrancosNulos, appendBrancosNulosComoCandidato } from '../helpers/append';
import {
  SAVE_ELEMENTS_STORE,
  SAVE_SCALES,
  MERGE_DATA_GEO,
  CHANGE_CURRENT_KEY,
  CHANGE_CURRENT_SCALE,
  // CHANGE_PARAMETER_FILTER,
  SAVE_DATA,
  SAVE_DATA_GEO,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from '../constants/ActionTypes';

export const saveElementsStore = context => ({
  type: SAVE_ELEMENTS_STORE,
  payload: context,
});

export const mergeDataGeo = data => ({
  type: MERGE_DATA_GEO,
  payload: data,
});

export const saveData = obj => ({
  type: SAVE_DATA,
  payload: obj,
});

export const saveDataGeo = obj => ({
  type: SAVE_DATA_GEO,
  payload: obj,
});

export const changeCurrentKey = key => ({
  type: CHANGE_CURRENT_KEY,
  payload: key,
});

export const saveScales = scales => ({
  type: SAVE_SCALES,
  payload: scales,
});

export const changeCurrentScale = scale => ({
  type: CHANGE_CURRENT_SCALE,
  payload: scale,
});

// export const changeParameterFilter = value => ({
//   type: CHANGE_PARAMETER_FILTER,
//   payload: value,
// });

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: data,
});

export const fetchFailure = error => ({
  type: FETCH_FAILURE,
  payload: error,
});

export const fetchBegin = () => async (dispatch) => {
  try {
    const { estado } = window;
    const MAP = await json('https://deoliyp60f2gq.cloudfront.net/eleicao-2018-mapas/governador/rj/json/brasil.json');
    const NEWDATA = await json('https://infograficos-estaticos.s3.amazonaws.com/eleicao-2018-mapas/governador/mg/governador_mg.json');
    // REMOVER ESSA LÓGICA DAQUI
    // const list = { NEWDATA, MAP };
    // const appenNewCandidatos = appendBrancosNulosComoCandidato(list);
    // const newListA = {
    //   ...list,
    //   NEWDATA: {
    //     ...appenNewCandidatos,
    //   },
    // };
    // const appendNewList = appendBrancosNulos(newListA);
    // const newListFinally = {
    //   ...list,
    //   NEWDATA: {
    //     ...appendNewList,
    //   },
    // };
    dispatch(fetchSuccess({ NEWDATA, MAP }));
    // dispatch(fetchSuccess(newListFinally));
  } catch (ex) {
    dispatch(fetchFailure(ex));
  }
};




// WEBPACK FOOTER //
// ./src/actions/index.js